<template>
  <div class="data_brain_wrap">
    <el-row class="card_wrap" type="flex">
      <div
        style="display: flex; width: 100%; height: 100%; align-items: center">
        <div
          style="
            width: 100%;
            height: 100%;
            background-color: #fff;
            position: relative;
          ">
          <div class="page-content">
            <!-- <div class="fenlei">
              <div
                v-for="(item, index) in articleType"
                :key="index"
                class="fenleilist">
                {{ item.name }}
              </div>
            </div> -->

            <div style="height: 100%; width: 74%">
              <el-carousel>
                <el-carousel-item v-for="(item, index) in ad1" :key="index">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item.link">
                    <img
                      :src="item.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <memberCenter style="width:25%;height:100%;"></memberCenter>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getArticle,
  AdList,
} from "@/api/user.js";
import memberCenter from "@/components/memberCenter/memberCenter.vue";
let settoken = null;
export default {
  components:{memberCenter},
  data() {
    return {
      currentPage: 1,
      pageSize: 10, // 每页显示的卡片数量
      // cardlist: [],
      // 所有数据
      // allData: [],
      // articleType: [],
      // content: "",
      cid: 0,
      ad1: [],
    };
  },
  computed: {
    // total() {
    //   return this.allData.length;
    // },
    // // 计算当前页面要显示的数据
    // currentPageContent() {
    //   const start = (this.currentPage - 1) * this.pageSize;
    //   const end = start + this.pageSize;
    //   return this.allData.slice(start, end);
    // },
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      const that = this;
      // getArticle({ cid: that.cid }).then((res) => {
      //   console.log(res);
      //   that.allData = res.data;
      //   that.articleType = res.clist;
      // });
      AdList(
        ['CONDITIONS-AD-1']
      ).then((res) => {
        console.log('resres',res);
        that.ad1 = res.data['CONDITIONS-AD-1'].data?JSON.parse(res.data['CONDITIONS-AD-1'].data):[];
      });
    },
    // 处理每页显示条目数变化
    handleSizeChange(newSize) {
      this.pageSize = newSize;
    },
    // 处理当前页码变化
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },
    handleNavigate() {
      this.$router.push("/production/1").catch((v) => {
        console.log(v);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 70px 0 0 0;
  background: #e8eef2;
  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }
  ::v-deep .el-carousel {
    height: 100%;

    .el-carousel__container {
      height: 100%;
    }
  }
  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    height: 660px;
    border-radius: 8px;
    position: relative;

    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .page-content {
      width: 100%;
      height: 100%;
      display: flex;
      // flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .cardInfo {
        padding: 1vw;
        width: 100%;
        height: 80%;
        background: linear-gradient(to bottom right, #ffffff, #94c0fe);
        display: flex;
        flex-direction: column;
        align-items: center;
        .cardTop {
          display: flex;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
        }
        .cardBody {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
          .fabu {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
          }
        }
        .vipbtn {
          margin-bottom: 1vw;
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          background: linear-gradient(to top, #1e037c, #2520ab);
          padding: 0.8vw;
          cursor: pointer;
          border-top-right-radius: 0.3vw;
          border-top-left-radius: 0.3vw;
        }
        .cardBottom {
          margin-bottom: 1vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
          .cardlist {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 30%;
            margin-bottom: 1vw;
          }
        }
        .loginout {
          width: 60%;
          height: 2vw;
          background-color: #f3f5f4;
          text-align: center;
          line-height: 2vw;
          font-size: 2ch;
          font-weight: 600;
          color: #b0b3b7;
          border-radius: 2%;
          cursor: pointer;
        }
      }
      .fenlei {
        width: 100%;
        padding: 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fenleilist {
          height: 2.5vw;
          width: 6vw;
          text-align: center;
          line-height: 2.5vw;
          background-color: #0d067e;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
    .ggw {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10%;
      width: 4%;
      margin-right: 1%;
    }
    .top-left {
      height: 100%;
      width: 20%;
      background-color: #0d067e;
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      .top-left-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }
      .top-left-info {
        width: 100%;
        flex: 1;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        padding: 30px 20px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .top-center {
      height: 100%;
      width: 50%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg {
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
